import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicCatalogComponent } from './dynamic-catalog/dynamic-catalog.component';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgZorroModule } from '@app/ng-zorro.module';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [DynamicCatalogComponent],
  imports: [
    CommonModule,
    FormsModule,
     NzSelectModule,
    NzDividerModule,
    NzRadioModule,
    NzTableModule,
    NzInputModule,
    NzIconModule,
    NgZorroModule,
    TranslateModule
  ],
  exports: [DynamicCatalogComponent]
})
export class CatalogSharedModule { }


